import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Sidebar.css";

const Sidebar = ({ pageType, isOpen, toggleSidebar }) => {
  const location = useLocation();
  const [userName, setUserName] = useState("");
  const [userRole, setUserRole] = useState("");

  useEffect(() => {
    const userStr = localStorage.getItem("user");
    if (userStr) {
      try {
        const user = JSON.parse(userStr);

        // Ad ve soyadı birlikte al
        const name = user.name || "";
        const surname = user.surname || "";
        const fullName = `${name} ${surname}`.trim();

        // Eğer ad ve soyad yoksa alternatif alanları dene
        if (!fullName) {
          const altName =
            user.full_name ||
            user.userName ||
            user.username ||
            user.email ||
            "Kullanıcı";
          setUserName(altName);
        } else {
          setUserName(fullName);
        }

        const role =
          user.role_name ||
          user.role ||
          (user.role_id === 1 ? "Admin" : "Personel") ||
          (user.isAdmin ? "Admin" : "Personel");
        setUserRole(role);
      } catch (error) {
        console.error("Kullanıcı bilgileri parse edilirken hata:", error);
      }
    }
  }, []);

  const adminMenuItems = [
    { name: "Ana Sayfa", icon: "fas fa-tachometer-alt", path: "/admin" },
    {
      name: "Personel Yönetimi",
      icon: "fas fa-users",
      path: "/admin/personnel",
    },
    {
      name: "Giriş/Çıkış İşlemleri",
      icon: "fas fa-sign-in-alt",
      path: "/admin/attendance",
    },
    { name: "Raporlar", icon: "fas fa-chart-bar", path: "/admin/reports" },
    { name: "Ayarlar", icon: "fas fa-cog", path: "/admin/settings" },
  ];

  const employeeMenuItems = [
    { name: "Ana Sayfa", icon: "fas fa-tachometer-alt", path: "/employee" },
    {
      name: "Haftalık Özet",
      icon: "fas fa-calendar-week",
      path: "/employee/weekly-summary",
    },
    {
      name: "Aylık Durumum",
      icon: "fas fa-calendar-alt",
      path: "/employee/monthly-status",
    },
    {
      name: "İzin Taleplerim",
      icon: "fas fa-calendar-times",
      path: "/employee/leave-request",
    },
    { name: "Profil", icon: "fas fa-user", path: "/employee/personal-info" },
  ];

  const menuItems = pageType === "admin" ? adminMenuItems : employeeMenuItems;

  const handleNavigation = (path) => {
    if (window.innerWidth <= 991.98) {
      toggleSidebar();
    }
  };

  return (
    <>
      <div
        className={`sidebar-overlay ${isOpen ? "active" : ""}`}
        onClick={toggleSidebar}
      ></div>
      <div className={`sidebar ${pageType}-sidebar ${isOpen ? "active" : ""}`}>
        <div className="sidebar-header">
          <h3 className="welcome-text">
            Hoş Geldiniz
            <span className="user-name">{userName}</span>
          </h3>
          <div className="user-role">
            <span className={`role-badge ${pageType}`}>{userRole}</span>
          </div>
        </div>
        <nav className="sidebar-nav">
          <ul>
            {menuItems.map((item, index) => (
              <li key={index}>
                <Link
                  to={item.path}
                  className={location.pathname === item.path ? "active" : ""}
                  onClick={() => handleNavigation(item.path)}
                >
                  <i className={item.icon}></i> {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <div className="sidebar-logo">
          <div className="logo-circle">
            <img src="/indir-Photoroom.png" alt="BİLİM KONYA Logo" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
